require('./cardsView.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const { getChildList } = require('actions/openYoungDashboard');
const commercialAdsAction = require('actions/commercialInterstitialsAds');
const getCollectivesProductList = require('actions/collectivesProductList');
const hireCardRevolvingActions = require('actions/hireCardRevolving');
const landingActions = require('actions/landings');
const cardTravelActions = require('actions/cardTravel');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CardsBox } = require('components/cards/cardsBox/cardsBox');
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKButton } = require('components/commons/OKButton/OKButton');
const CardsBenefitsLinks = require('components/cards/cardBenefits/cardBenefitsLinks/cardBenefitsLinks');
const CardsProductBanners = require('components/cards/cardsProductBanners/cardsProductBanners');
const CardsProductCMSBanners = require('components/cards/cardsProductCMSBanners/cardsProductCMSBanners');
const CardsProductDropdown = require('components/contactCenter/cards/cardsProductDropdown/cardsProductDropdown');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const OpenYoungDashboardInfo = require('components/openYoungDashboard/openYoungDashboardInfo/openYoungDashboardInfo');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const WebappRender = require('components/conditionalRender/webappRender');

// @helpers
const { getCommercialCardsList } = require('utilities/commercialAdsHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { existCancelledCards } = require('utilities/contactCenter/cancelledCardsHelper');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname');

// @constants
const {
    GC,
    NOT_ALLOWED_OY_DASHBOARD_COUNTRIES,
    R42_BENEFITS_AND_INSURANCE,
    R42_BENEFITS_AND_INSURANCE_ACCESS,
    WEB_OY_DASHBOARD_ENABLED,
} = require('constants/flagBasedFeatures');
const { GRAPHIC_TUTOR_TYPE_6 } = require('constants/index');
const { INACTIVE_STATUS_LIST, CANCELLED_STATUS } = require('constants/contactCenter/cardStatus');
const { TRAVEL_PLUS_R42 } = require('constants/flagBasedFeatures');

class CardsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildCards = this.buildCards.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleCardsBoxClick = this.handleCardsBoxClick.bind(this);
    }

    componentDidMount() {
        const {
            flagBasedFeatures,
            getCollectivesProductList,
            getScoring,
            immCards,
            immCollectivesProductList,
            immProfile,
            requestAds,
            revolvingEnabled,
            setCardTravelPlus,
        } = this.props;

        const commercialCardsList = getCommercialCardsList(immCards, flagBasedFeatures, immProfile);

        if (revolvingEnabled) {
            getScoring();
        }

        if (immProfile.get('isCollective') && !immCollectivesProductList.get('hasBeenFetched')) {
            getCollectivesProductList();
        }

        if (flagBasedFeatures.get(TRAVEL_PLUS_R42) && immCards.get('cardNumbersTravelPlus').size > 0) {
            setCardTravelPlus();
        }
        requestAds(commercialCardsList, 'allCards');
        scrollToTop();
    }

    buildCards() {
        const {
            immCards,
            immCardsTransactions,
            immCommercialAds,
            immLandingBoxes,
            immProfile,
        } = this.props;

        const immCardsList = immCards.get('byOrder');

        let sectionContent;

        if (!!immCards.get('error')) {
            sectionContent = this.buildConnectionError();
        } else if (immCards.get('byId').isEmpty()) {
            sectionContent = <div />;
        } else {
            sectionContent = immCardsList
                .filter(cardId => immCards.getIn(['byId', cardId, 'visibleinCards']))
                .map((cardId, cardIndex) => {
                    const immCardsById = immCards.get('byId');
                    const expanded = immLandingBoxes.includes(cardIndex);
                    return (
                        <CardsBox
                            expanded={expanded}
                            key={cardIndex}
                            cardIndex={cardIndex}
                            immCard={immCardsById.get(cardId)}
                            immCommercialAds={immCommercialAds}
                            immCardsTransactions={immCardsTransactions}
                            onClick={this.handleCardsBoxClick}
                            immProfile={immProfile}
                        />
                    );
                });
        }

        return (
            <div>
                {sectionContent}
            </div>
        );
    }

    buildCardsCC() {
        const { immCards, immCommercialAds, immCardsTransactions, immLandingBoxes } = this.props;
        const immCardsList = immCards.get('byOrder');
        const cancelledView = this.isCancelledView();

        let sectionContent;
        let rightSection = [];
        let leftSection = [];

        if (!!immCards.get('error')) {
            sectionContent = this.buildConnectionError();
        } else if (immCards.get('byId').isEmpty()) {
            sectionContent = <div />;
        } else {
            sectionContent = immCardsList.filter(cardId => {
                return immCards.getIn(['byId', cardId, 'visibleinCards']);
            });

            sectionContent = sectionContent.filter((cardId) => {
                const immCard = immCards.getIn(['byId', cardId]);
                const cardStatus = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
                const isCancelledCard = INACTIVE_STATUS_LIST.includes(cardStatus);
                return cancelledView ? isCancelledCard : !isCancelledCard;
            });

            sectionContent = sectionContent.map((cardId, cardIndex) => {
                const immCardsById = immCards.get('byId');
                const expanded = (immLandingBoxes.includes(cardId)) ? true : immLandingBoxes.includes(cardIndex);

                const card = (
                    <CardsBox
                        expanded={expanded}
                        key={cardIndex}
                        cardIndex={cardIndex}
                        immCard={immCardsById.get(cardId)}
                        immCommercialAds={immCommercialAds}
                        immCardsTransactions={immCardsTransactions}
                        onClick={this.handleCardsBoxClick} />
                );

                (cardIndex % 2 == 0) ? leftSection.push(card) : rightSection.push(card);

                return card;
            });

        }

        return {
            sectionContent: (<section className="cards-view__cards">{sectionContent}</section>),
            rightSection: (<section className="cards-view__cards">{rightSection}</section>),
            leftSection: (<section className="cards-view__cards">{leftSection}</section>)
        };
    }

    buildConnectionError() {
        const lostConnectionFirstLine = formatText('cards-lostConnectionFirstLine');

        return (
            <OKSectionBox>
                <EmptyState primaryText={lostConnectionFirstLine} iconType="nointernet-banking" />
                <div className="text-center">
                    <OKButton onClick={this.handleRetry}>
                        <FormattedText value="cards-retry" />
                    </OKButton>
                </div>
            </OKSectionBox>
        );
    }

    buildCardsProductBanners() {
        const {
            immCards,
            immCommercialAds,
            immHireCardRevolving,
            immProfile,
        } = this.props;
        const isCollectiveUser = immProfile.get('isCollective') || false;
        const fetchingScoring = immHireCardRevolving.get('isFetchingScoring');

        return fetchingScoring
            ? <LoadingSection />
            : (
                <CardsProductBanners
                    amount={10}
                    immCards={immCards}
                    immCommercialAds={immCommercialAds}
                    isCollectiveUser={isCollectiveUser}
                    showRevolving={immHireCardRevolving.get('enabled')}
                />
            );
    }

    handleCardsBoxClick(isExpanded, accountId) {
        const { boxToggle } = this.props;
        boxToggle(isExpanded, accountId, 'cards');
    }

    handleRetry() {
        //TODO ADD LOGIC HERE.
    }

    handleGoToCancelledCards() {
        this.props.history.push('/myprofile/cards/cancelled');
    }

    isCancelledView() {
        return window.location.pathname.includes("cancelled");
    }

    buildCardsProductCMSBanners() {
        const {
            immCards,
            immHireCardRevolving,
            immProfile,
        } = this.props;

        return (
            <CardsProductCMSBanners
                limit={10}
                immCards={immCards}
                immProfile={immProfile}
                showRevolving={immHireCardRevolving.get('enabled')}
            />
        );
    }

    render() {
        const {
            flagBasedFeatures,
            gestorCrossEnabled,
            getChildList,
            immCards,
            immHireCardRevolving,
            immOpenYoungDashboard,
        } = this.props;
        const cards = !__CONTACT_CENTER__ ? this.buildCards() : this.buildCardsCC()
        const cardsProductBanners = gestorCrossEnabled && flagBasedFeatures.get(GC) ? this.buildCardsProductCMSBanners() : this.buildCardsProductBanners();
        const title = formatText('landingHeader-cards');
        const hasDiamondCard = immCards.get('hasDiamondPack');
        const hasPremiumCard = immCards.get('hasPremiumPack');
        const hasR42BenefitsAccess = flagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE) && flagBasedFeatures.get(R42_BENEFITS_AND_INSURANCE_ACCESS) && immCards.get('hasR42Benefits');
        const cardId = immCards.get('cardId');
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_6}
                title={formatText('tutorials-cardsTitle')}
            />
        );
        let cardBenefitsComponent;

        if (hasDiamondCard || hasPremiumCard || hasR42BenefitsAccess) {
            cardBenefitsComponent = (
                <CardsBenefitsLinks
                    cardId={cardId}
                    hasDiamondCard={hasDiamondCard}
                    hasPremiumCard={hasPremiumCard}
                    hasR42BenefitsAccess={hasR42BenefitsAccess}
                />
            );
        }

        const cancelledCardsButton = __CONTACT_CENTER__ && !this.isCancelledView() && (
            <OKButton modifier={"primary"} onClick={() => this.handleGoToCancelledCards()} disabled={!existCancelledCards(immCards)}>
                <FormattedText value="cards-seeCancelledCards" />
            </OKButton>
        );

        const breadcrumbCancelledCards = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText('cards-subtitleCancelledCards'),
                url: ''
            }
        ];

        const OKHeaderView = this.isCancelledView() ? (
            <OKCover size="medium" section="cards" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumbCancelledCards}
                    finalTitle={formatText('landingHeader-cards')}
                    subtitleLeft={formatText('cards-subtitleCancelledCards')}
                    tutorial={tutorial}
                    className="ok-header-landing--accounts"
                >
                    <CardsProductDropdown immCards={immCards} immHireCardRevolving={immHireCardRevolving} amount={10} />
                </OKHeaderSubPage>
            </OKCover>
        ) : (
            <OKCover size="small" section="cards" customClass="col-xs-12">
                <OKHeaderLanding
                    title={title}
                    tutorial={tutorial}
                    inputClassName="ok-header-landing--cards"
                >
                    {cancelledCardsButton}
                    <ContactCenterRender>
                        <CardsProductDropdown immCards={immCards} immHireCardRevolving={immHireCardRevolving} amount={10} />
                    </ContactCenterRender>
                </OKHeaderLanding>
            </OKCover>
        );

        const gridBodyClassName = contactCenterClassName('cards-view__body', 'grid-view__body');
        const leftColumnClassName = conditionalClassName('col-xs-12 col-md-8 col-lg-8', 'cards-view__left-column col-xs-6');
        const rightColumnClassName = conditionalClassName('col-xs-12 col-md-4 col-lg-4', 'cards-view__right-column col-xs-6');

        const bodyClassNames = classNames('container-fluid', 'grid-view--content-position-positive')

        let oyDashboardInfoSection;
        if (flagBasedFeatures.get(WEB_OY_DASHBOARD_ENABLED) && flagBasedFeatures.get(NOT_ALLOWED_OY_DASHBOARD_COUNTRIES)) {
            oyDashboardInfoSection = (
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                    <OpenYoungDashboardInfo
                        getChildList={getChildList}
                        immOpenYoungDashboard={immOpenYoungDashboard}
                    />
                </div>
            );
        }
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        {OKHeaderView}
                    </div>
                </div>
                <div className={gridBodyClassName}>
                    <div className={bodyClassNames}>
                        <div className="row">
                            <div className={leftColumnClassName}>
                                <div className="row">
                                    <ContactCenterRender>
                                        {cards.leftSection}
                                    </ContactCenterRender>
                                    <WebappRender>
                                        <div className="col-xs-12">
                                            {cards}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-12">
                                            {cardsProductBanners}
                                        </div>
                                    </WebappRender>
                                </div>
                            </div>
                            <div className={rightColumnClassName}>
                                <div className="row">
                                    <ContactCenterRender>
                                        {cards.rightSection}
                                    </ContactCenterRender>
                                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                                        <CommercialAds path="cards" type="banner-b" excludeType="cards" />
                                    </div>
                                    {oyDashboardInfoSection}

                                    <WebappRender>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                            <CallMeBack isSmall={true} pageTitle={formatText('breadcrumb-cards')} hasEntrance={false} />
                                            <div className="grid-view--fix-cell-separation">
                                                {cardBenefitsComponent}
                                            </div>
                                        </div>
                                    </WebappRender>

                                </div>
                            </div>
                            <WebappRender>
                                <div className="col-xs-12 hidden-md hidden-lg">
                                    {cardsProductBanners}
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        <CommercialAds path="cards" type="cross-selling" />
                    </div>
                </div>
            </div>
        );
    }
}

CardsView.propTypes = {
    boxToggle: PropTypes.func,
    children: PropTypes.any,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    getChildList: PropTypes.func.isRequired,
    getCollectivesProductList: PropTypes.func,
    getScoring: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    immCollectivesProductList: PropTypes.object,
    immCommercialAds: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
    immLandingBoxes: PropTypes.object,
    immOpenYoungDashboard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    requestAds: PropTypes.func.isRequired,
    revolvingEnabled: PropTypes.bool,
    setCardTravelPlus: PropTypes.func.isRequired,
};

module.exports.constructor = CardsView;
module.exports.CardsView = connect(state => ({
    flagBasedFeatures: state.flagBasedFeatures,
    gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
    immCards: state.cards,
    immCardsTransactions: state.cardsTransactions,
    immCollectivesProductList: state.collectivesProductList,
    immCommercialAds: state.commercialAds,
    immHireCardRevolving: state.hireCardRevolving,
    immLandingBoxes: state.landings.get('expandedBoxes').get('cards'),
    immOpenYoungDashboard: state.openYoungDashboard,
    immProfile: state.profile,
    revolvingEnabled: state.flagBasedFeatures.get('hire-card-revolving-enabled'),
}), {
    boxToggle: landingActions.boxToggle,
    getChildList,
    getCollectivesProductList,
    getScoring: hireCardRevolvingActions.getScoring,
    requestAds: commercialAdsAction.requestAds,
    setCardTravelPlus: cardTravelActions.setCardTravelPlus,
})(withRouter(CardsView));
